(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-progress"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.thegesShippingProgressInitialized) return;
  window.thegesShippingProgressInitialized = true;

  const money = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR'
  });

  const setProgress = (element, progress) => {
    const track = element.querySelector('[data-shipping-track]');
    const bar = element.querySelector('[data-shipping-bar]');

    if (!track || !bar) return;

    const boundedProgress = Math.max(
      0,
      Math.min(100, progress)
    );

    track.hidden = false;
    track.setAttribute(
      'aria-valuenow',
      String(Math.round(boundedProgress))
    );

    bar.style.width = `${boundedProgress}%`;
  };

  const hideProgress = (element) => {
    const track = element.querySelector('[data-shipping-track]');
    const bar = element.querySelector('[data-shipping-bar]');

    if (track) {
      track.hidden = true;
      track.removeAttribute('aria-valuenow');
    }

    if (bar) {
      bar.style.width = '0%';
    }
  };

  const renderBar = (element) => {
    const total = Number(element.dataset.cartTotal || 0);
    const region = element.dataset.initialRegion || 'other';
    const isBanner =
      element.dataset.shippingVariant === 'banner';

    const message = element.querySelector(
      '[data-shipping-message]'
    );

    if (!message) return;

    const setMessage = (
      panelText,
      bannerText = panelText
    ) => {
      message.textContent =
        isBanner ? bannerText : panelText;
    };

    /*
     * No intentamos detectar Canarias mediante impuestos
     * u otras propiedades del carrito.
     *
     * Solo se considera Canarias cuando existe una
     * dirección conocida del cliente con provincia GC/TF.
     *
     * Para visitantes españoles sin dirección conocida,
     * mostramos Península como referencia y Shopify
     * calculará la tarifa definitiva en checkout.
     */

    if (
      region !== 'peninsula' &&
      region !== 'canarias'
    ) {
      hideProgress(element);

      setMessage(
        'El envío se calculará automáticamente según tu ubicación en el checkout.',
        '🚚 Envío calculado según tu ubicación'
      );

      return;
    }

    /*
     * PENÍNSULA
     *
     * Envío estándar:
     * 4,95 €
     *
     * Envío gratis:
     * desde 25,00 €
     */
    if (region === 'peninsula') {
      const threshold = 2500;

      if (total >= threshold) {
        setMessage(
          'Ya tienes envío gratis.',
          '🚚 Ya tienes envío gratis'
        );

        setProgress(element, 100);
      } else {
        const remaining = money.format(
          (threshold - total) / 100
        );

        setMessage(
          `Te faltan ${remaining} para conseguir envío gratis.`,
          `🚚 Añade ${remaining} para conseguir envío gratis`
        );

        setProgress(
          element,
          (total / threshold) * 100
        );
      }

      return;
    }

    /*
     * CANARIAS
     *
     * Hasta 59,99 €:
     * 31,95 €
     *
     * Desde 60,00 € hasta 89,98 €:
     * 14,95 €
     *
     * Desde 89,99 €:
     * gratis
     */

    if (region === 'canarias') {
      const reducedShippingThreshold = 6000;
      const freeShippingThreshold = 8999;

      if (total < reducedShippingThreshold) {
        const remaining = money.format(
          (reducedShippingThreshold - total) / 100
        );

        setMessage(
          `El envío cuesta 31,95 €. Añade ${remaining} para reducirlo a 14,95 €.`,
          `🚚 Añade ${remaining} y el envío baja a 14,95 €`
        );

        setProgress(
          element,
          (total / reducedShippingThreshold) * 100
        );

        return;
      }

      if (total < freeShippingThreshold) {
        const remaining = money.format(
          (freeShippingThreshold - total) / 100
        );

        setMessage(
          `Tu envío cuesta 14,95 €. Te faltan ${remaining} para conseguir envío gratis.`,
          `🚚 Añade ${remaining} para conseguir envío gratis`
        );

        setProgress(
          element,
          (
            (total - reducedShippingThreshold) /
            (
              freeShippingThreshold -
              reducedShippingThreshold
            )
          ) * 100
        );

        return;
      }

      setMessage(
        'Ya tienes envío gratis.',
        '🚚 Ya tienes envío gratis'
      );

      setProgress(element, 100);
    }
  };

  const renderAll = () => {
    document
      .querySelectorAll('[data-shipping-progress]')
      .forEach((element) => {
        renderBar(element);
      });
  };

  /*
   * Actualización automática al modificar el carrito.
   *
   * Solo actualizamos el total.
   * NO modificamos la región basándonos en taxes_included.
   */
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        const cartData = event?.cartData;
        const total = Number(
          cartData?.total_price
        );

        if (!Number.isFinite(total)) return;

        document
          .querySelectorAll('[data-shipping-progress]')
          .forEach((element) => {
            element.dataset.cartTotal =
              String(total);
          });

        renderAll();
      }
    );
  }

  /*
   * Renderiza automáticamente nuevas instancias
   * añadidas dinámicamente por el theme.
   */
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (
          node.matches('[data-shipping-progress]')
        ) {
          renderBar(node);
        }

        node
          .querySelectorAll?.(
            '[data-shipping-progress]'
          )
          .forEach((element) => {
            renderBar(element);
          });
      });
    });
  }).observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

  renderAll();
})();
  } catch(e) { console.error(e); }
})();

})();
